import React from 'react';
import { Container, LeftArrow, RightArrow, BottomArrow, TopArrow } from './arrow-styles';
import InnerTriangle from './inner-triangle';
var Arrow = function (_a) {
    var direction = _a.direction;
    switch (direction) {
        case 'right':
            return (React.createElement(Container, null,
                React.createElement(RightArrow, null,
                    React.createElement(InnerTriangle, null))));
        case 'top':
            return (React.createElement(Container, null,
                React.createElement(TopArrow, null,
                    React.createElement(InnerTriangle, null))));
        case 'bottom':
            return (React.createElement(Container, null,
                React.createElement(BottomArrow, null,
                    React.createElement(InnerTriangle, null))));
        default:
            return (React.createElement(Container, null,
                React.createElement(LeftArrow, null,
                    React.createElement(InnerTriangle, null))));
    }
};
export default Arrow;
